"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Sigma.js Captor Class
 * ======================
 *
 * Abstract class representing a captor like the user's mouse or touch controls.
 */
var events_1 = require("events");
var Captor = /** @class */ (function (_super) {
    __extends(Captor, _super);
    function Captor(container, camera) {
        var _this = _super.call(this) || this;
        // Properties
        _this.container = container;
        _this.camera = camera;
        return _this;
    }
    return Captor;
}(events_1.EventEmitter));
exports.default = Captor;
